import { defineChain } from 'viem'

export const geekVerse = defineChain({
  id: 75512,
  name: 'GEEK Verse',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.geekout-pte.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'GeekVerse-Mainnet explorer',
      url: 'https://explorer.geekout-pte.com',
      apiUrl: 'https://explorer.geekout-pte.com/api',
    },
  },
  testnet: false,
})
